import { createContext } from "react";
const CycleContext = createContext();
export default CycleContext;